<div class="select-dnd">
  <div class="select-list available">
    <h3 *ngIf="leftTitle">
      {{ leftTitle }}
    </h3>
    <div
      class="listbox-wrapper"
      style="position: relative; display: inline-block"
    >
      <p-listbox
        #availableListbox
        [options]="initialAvailableItems"
        [listStyle]="{ height: '200px' }"
        [showToggleAll]="true"
        [dataKey]="'id'"
        [filterBy]="'label'"
        [filter]="true"
        [optionLabel]="'label'"
        id="availableItems"
      >
        <ng-template let-item pTemplate="item">
          <div
            [ngClass]="{
              added: !isOnAvailableItems(item),
              'button-item': true
            }"
            (click)="onAddClick(item); $event.stopPropagation()"
          >
            <button type="button" pTooltip="{{ 'ADD' | translate }}">
              <i class="pi pi-check" *ngIf="!isOnAvailableItems(item)"></i>
            </button>
            <div class="service-info">
              <div class="hospital-name" *ngIf="item.data?.hospitalName">
                {{ item.data.hospitalName }}
              </div>
              <span>{{ item.label }}</span>
            </div>
          </div>
        </ng-template>
      </p-listbox>

      <!-- Botón a la izquierda del filtro -->
      <button
        type="button"
        class="'add-all-button'"
        pButton
        (click)="addAll()"
        style="
          position: absolute;
          top: 15px;
          left: 21px;
          z-index: 10;
          padding: 6px;
        "
      >
        <i class="pi pi-check" *ngIf="isAllSelected()"></i>
      </button>
    </div>
  </div>

  <div class="select-list selected">
    <h3 *ngIf="rightTitle" class="h3-button">{{ rightTitle }}
      <button
        type="button"
        class="remove-all-button"
        pButton
        (click)="removeAll()"
        style="margin-left: 10px; padding: 6px;"
      >{{ 'REMOVE_ALL' | translate }}</button>

    </h3>
    <p-listbox
      #selectedListbox
      [options]="selectedItems"
      [listStyle]="{ height: '200px' }"
      [showToggleAll]="true"
      [dataKey]="'id'"
      [filterBy]="'label'"
      [filter]="true"
      [optionLabel]="'label'"
      formControlName="selectedItems"
    >
      <ng-template let-item pTemplate="item">
        <div class="button-item">
          <div class="service-info">
            <div class="hospital-name" *ngIf="item.data?.hospitalName">
              {{ item.data.hospitalName }}
            </div>
            <span>{{ item.label }}</span>
          </div>
          <button
            type="button"
            pTooltip="{{ 'REMOVE' | translate }}"
            (click)="onRemoveClick(item); $event.stopPropagation()"
          >
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </ng-template>
    </p-listbox>
  </div>
</div>
